import { ThemeProvider } from "@shopify/restyle";
import { theme } from "@theme";
import LBox from "@components/LBox";
import LButton from "@components/LButton";
import LText from "@components/LText";

/**
 * Shown in place of the app when the last account's data could not be wiped
 * from the device. No session is open, so this renders outside every app
 * provider.
 */
export function SessionEndFailed({
  onRetry,
}: {
  onRetry: () => Promise<void>;
}) {
  return (
    <ThemeProvider theme={theme}>
      <LBox
        flex={1}
        backgroundColor="screenBg"
        justifyContent="center"
        paddingHorizontal="s4"
        gap="l3"
      >
        <LBox gap="m1">
          <LText textAlign="center" variant="lead-medium">
            Something went wrong
          </LText>
          <LText textAlign="center" variant="h1">
            {"We couldn't finish signing out on this device."}
          </LText>
        </LBox>
        <LButton
          sentryEventName="session_end_failed_retry"
          label="Try again"
          onPress={onRetry}
        />
      </LBox>
    </ThemeProvider>
  );
}
